import { createSlice } from '@reduxjs/toolkit';
import { 
  setAuthCookie, 
  clearAllAuthCookies, 
  getUserRoleFromCookies, 
  getUserDataFromCookies,
  isCookieValid 
} from '../../utils/cookieUtils';

const initialState = {
  user: null,
  isAuthenticated: false,
  isLoading: true,
  role: null,
  token: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // Initialize auth state from cookies
    initializeAuth: (state) => {
      const userData = getUserDataFromCookies();
      if (userData) {
        state.user = userData;
        state.isAuthenticated = true;
        state.role = userData.role;
        state.token = userData.token;
      } else {
        state.user = null;
        state.isAuthenticated = false;
        state.role = null;
        state.token = null;
      }
      state.isLoading = false;
    },

    // Login action
    login: (state, action) => {
      const { userData, token, role } = action.payload;
      
      // Set appropriate cookie based on role
      let cookieName;
      switch (role) {
        case "أدمن":
          cookieName = "auth_tokena";
          break;
        case "طالب":
          cookieName = "auth_token";
          break;
        default:
          throw new Error('Invalid user role');
      }

      // Set authentication cookie (expires in 1 day)
      setAuthCookie(cookieName, token, userData, 1);
      
      state.user = {
        ...userData,
        role,
        token
      };
      state.isAuthenticated = true;
      state.role = role;
      state.token = token;
      state.isLoading = false;
    },

    // Logout action
    logout: (state) => {
      // Clear all authentication cookies
      clearAllAuthCookies();
      
      state.user = null;
      state.isAuthenticated = false;
      state.role = null;
      state.token = null;
      state.isLoading = false;
    },

    // Set loading state
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },

    // Clear auth state (for cleanup)
    clearAuth: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.role = null;
      state.token = null;
      state.isLoading = false;
    }
  },
});

export const { 
  initializeAuth, 
  login, 
  logout, 
  setLoading, 
  clearAuth 
} = authSlice.actions;

// Selectors
export const selectUser = (state) => state.auth.user;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectIsLoading = (state) => state.auth.isLoading;
export const selectUserRole = (state) => state.auth.role;
export const selectToken = (state) => state.auth.token;

// Helper selectors
export const selectHasRole = (role) => (state) => state.auth.role === role;
export const selectHasAnyRole = (roles) => (state) => roles.includes(state.auth.role);

export default authSlice.reducer;
